import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ApartmentIcon from '@mui/icons-material/Apartment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import fetch from '../../../Api/definitionCoursePage';

// El morado es de los tres obligatorios: el color agrupa, no decora. Opcionales
// conserva su ámbar justamente porque no pertenece a esa cascada.
const MANDATORY_BG = '#f1eafb';
const MANDATORY_COLOR = '#7c3aed';

/**
 * Las cuatro áreas de definición. Es una constante de módulo, no un estado: lo
 * único que cambia al cargar es el conteo, y ese vive aparte para que la
 * pantalla se pinte completa desde el primer render en vez de esperar a la red.
 *
 * `group` separa la cascada de alcance —empresa, departamento, puesto, de lo
 * más amplio a lo más específico— de los opcionales, que no obligan a nadie.
 */
const SECTIONS = [
  {
    id: 'enterprise',
    group: 'mandatory',
    icon: <ApartmentIcon />,
    iconBg: MANDATORY_BG,
    iconColor: MANDATORY_COLOR,
    titleKey: 'CardEnterpriseTitle',
    descriptionKey: 'CardEnterpriseDescription',
    countKey: 'countByEnterprise',
    route: '/definicion/empresa',
  },
  {
    id: 'department',
    group: 'mandatory',
    icon: <DashboardIcon />,
    iconBg: MANDATORY_BG,
    iconColor: MANDATORY_COLOR,
    titleKey: 'CardDepartmentTitle',
    descriptionKey: 'CardDepartmentDescription',
    countKey: 'countByDepartment',
    route: '/definicion/seleccion/departamento',
  },
  {
    id: 'jobTitle',
    group: 'mandatory',
    icon: <AssignmentIndIcon />,
    iconBg: MANDATORY_BG,
    iconColor: MANDATORY_COLOR,
    titleKey: 'CardJobTitleTitle',
    descriptionKey: 'CardJobTitleDescription',
    countKey: 'countByJobTitle',
    route: '/definicion/seleccion/puesto',
  },
  {
    id: 'optional',
    group: 'optional',
    icon: <StarBorderIcon />,
    iconBg: '#fdf2e7',
    iconColor: '#e08a1e',
    titleKey: 'CardOptionalTitle',
    descriptionKey: 'CardOptionalDescription',
    countKey: 'countOptional',
    route: '/definicion/opcionales',
  },
];

/**
 * Alimenta el hub de definición: las cuatro áreas con su conteo de cursos y la
 * navegación a cada una.
 *
 * Mientras la petición vuela, `count` va en `undefined` y la tarjeta esconde la
 * píldora: un cero mientras carga se lee como "no hay cursos definidos".
 */
const useInformation = () => {
  const history = useHistory();
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    let isMounted = true;

    fetch().then(data => {
      if (!isMounted || !data) return;
      setCounts(data);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const sections = SECTIONS.map(section => ({
    ...section,
    count: counts ? counts[section.countKey] : undefined,
  }));

  const goTo = route => {
    history.push({
      pathname: route,
      state: {
        isComingFrom: '/definicion',
      },
    });
  };

  return { sections, goTo };
};

export default useInformation;
